export default __webpack_public_path__ + "static/media/furniture8.569144c1.jpeg";